<template>
    <v-dialog v-model="show" no-click-animation persistent width="800">
        <div class="ScenarioVariable">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('variable') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar" ref="contentDialog">
                <!--Table variables-->
                <table style="border-top: none !important;">
                    <thead style="position: sticky !important; top: -1px; z-index:1">
                    <!-- this tr is for border top to follow the header when scrolling -->
                    <tr style="height: 2px !important">
                        <th style="padding:0;background: #96add0" :colspan="isEdit ? '6' : '5'"></th>
                    </tr>
                    <tr>
                        <th style="padding: 12px; width: 200px">
                            <div class="d-flex">
                                {{ $f.tc('name') }}
                            </div>
                        </th>
                        <th>{{ $f.tc('defaultValue') }}</th>
                        <th class="text-center" style="width: 90px">
                            <div class="centerXY  ">
                                {{ $f.tc('save') }}
                                <div class="tooltip">
                                    <v-icon size="16" color="#0052CC" class="ml-1">
                                        mdi-help-circle
                                    </v-icon>
                                    <p class="tooltiptext" style="top:37px; right:60px">
                                        {{ $t('scenarioVariable.helpCircle') }}</p>
                                </div>

                            </div>
                        </th>
                        <th style="width: 90px">
                            <div class="centerXY">
                                {{ $f.tc('masking') }}
                                <div class="tooltip">
                                    <v-icon size="16" color="#0052CC" class="ml-1">
                                        mdi-help-circle
                                    </v-icon>
                                    <p class="tooltiptext" style="top:37px; right:25px">
                                        {{ $t('scenarioVariable.masking') }}</p>
                                </div>
                            </div>
                        </th>
                        <th class="text-center" style="width: 90px">
                            <div class="centerXY">
                                {{ $f.tc('sensitive') }}
                                <div class="tooltip">
                                    <v-icon size="16" color="#0052CC" class="ml-1">
                                        mdi-help-circle
                                    </v-icon>
                                    <p class="tooltiptext" style="top:37px; right:3px">
                                        {{ $t('scenarioVariable.sensitive') }}</p>
                                </div>
                            </div>
                        </th>
                        <th v-if="isEdit"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--Current variables-->
                    <tr v-for="(item, i) in itemList" :key="i">
                        <td>
                            <v-text-field
                                outlined
                                v-model="itemList[i].name"
                                :class="systemVariables.map(function (obj) {return obj.name}).includes(itemList[i].name)?'input-custom-2':'input-custom'"
                                style="width: 100%"
                                :readonly="!isEdit"
                                @click:append="notifyError(itemList[i].name)"
                                :append-icon="systemVariables.map(function (obj) {return obj.name}).includes(itemList[i].name)?'mdi-information':''"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="itemList[i].default_value"
                                class="input-custom"
                                style="width: 100%"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-checkbox
                                hide-details
                                v-model="itemList[i].should_save"
                                :disabled="!isEdit"
                                color="#0052CC"
                                style="margin-left: 26px"
                            ></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox
                                hide-details
                                v-model="itemList[i].masking"
                                :disabled="!isEdit"
                                color="#0052CC"
                                style="margin-left: 26px"
                            ></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox
                                hide-details
                                v-model="itemList[i].sensitive"
                                :disabled="!isEdit"
                                color="#0052CC"
                                style="margin-left: 26px"
                            ></v-checkbox>
                        </td>
                        <td v-if="isEdit">
                            <v-btn icon class="mx-0" @click.stop="deleteItem(i)">
                                <img
                                    src="/img/delete-blue.svg"
                                    alt="icon-delete"
                                    style="transform: scale(1.3); padding-left: 1px"
                                >
                            </v-btn>
                        </td>
                    </tr>
                    <!--New variable-->
                    <tr v-if="isEdit">
                        <td>
                            <v-text-field
                                outlined
                                v-model="model.name"
                                class="input-custom"
                                @keypress.enter="addItem"
                                :placeholder="$f.tc('enterName')"
                                style="width: 100%"
                                ref="NewKeyVariable"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="model.default_value"
                                class="input-custom"
                                @keypress.enter="addItem"
                                :placeholder="$f.tc('enterDefaultValue')"
                                style="width: 100%"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-checkbox
                                hide-details
                                style="margin-left: 26px"
                                v-model="model.should_save"
                                color="#0052CC"
                            ></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox
                                hide-details
                                style="margin-left: 26px"
                                v-model="model.masking"
                                color="#0052CC"
                            ></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox
                                hide-details
                                style="margin-left: 26px"
                                v-model="model.sensitive"
                                color="#0052CC"
                            ></v-checkbox>
                        </td>
                        <td>
                            <v-btn icon class="mx-0" @click.stop="addItem">
                                <img src="/img/add-blue.svg" alt="icon-delete" style="transform: scale(1.4);">
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer" v-if="isEdit">
                <div style="margin-right:8px">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <div class="btn-custom-normal" v-on="on">{{ $f.tc('systemVar') }}</div>
                        </template>
                        <table class="additional-data">
                            <thead>
                            <tr>
                                <td><b>{{ $f.tc('name') }}</b></td>
                                <td><b>{{ $f.tc('description') }}</b></td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in systemVariables" :key="index">
                                <td>{{ item.name }}</td>
                                <td>{{ item.description }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </v-tooltip>
                </div>
                <div class="btn-custom"
                     @click="saveList">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";
import ScenarioService from "@/services/scenario.service";
import lodash from 'lodash'
import {mapState} from "vuex";

const defaultNewVariable = {
    name: '',
    default_value: '',
    should_save: false,
    masking: false,
    sensitive: false,
}

export default {
    name: "ScenarioVariable",
    mixins: [DialogPromiseMixin],
    data() {
        return {
            model: this.$utils.cloneObject(defaultNewVariable),
            errorMessage: '',
            itemList: [],
            systemVariables: [],
        }
    },
    computed: {
        ...mapState({
            variableList: state => state.scenario.variableList
        }),
        isEdit() {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        originalItemMap() {
            let map = {}
            for (let item of this.variableList) {
                map[item.name] = item
            }
            return map
        }
    },
    mounted() {
        ScenarioService.getSystemVariables().then((res) => {
            this.systemVariables = res.data
        }).catch(() => {
            this.$appService.toastError('load system variable failed')
        })
    },
    destroyed() {
        this.$store.commit(this.$actionTypes.scenario.VARIABLE, [])
    },
    methods: {
        loadVariable() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_VARIABLE, this.$route.params.scenarioId)
        },
        open() {
            this.model = this.$utils.cloneObject(defaultNewVariable)
            this.loadVariable()

            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        addItem() {
            if (this.newVariableIsValid()) {
                this.itemList.push(this.model)
                this.scrollBottom()
                this.model = this.$utils.cloneObject(defaultNewVariable)
                this.$refs.NewKeyVariable.$el.focus()
            }
        },
        newVariableIsValid() {
            if (!this.model.name) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('name')}))
                return false
            }

            if (this.itemList.find(item => item.name === this.model.name)) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicate', {
                    key: this.$f.tc('name'),
                    value: this.model.name
                }))
                return false
            }

            return true
        },
        deleteItem(index) {
            this.itemList.splice(index, 1)
        },
        saveList() {
            let addList = []
            let updateList = []
            let deleteList = []
            for (let item of this.itemList) {
                item['name'] = item['name'].trim()
                item['default_value'] = item['default_value'].trim()
                let originalItem = this.originalItemMap[item.name]
                if (originalItem) {
                    originalItem.doNotDelete = true
                    if (
                        item.default_value !== originalItem.default_value
                        || item.should_save !== originalItem.should_save
                        || item.masking !== originalItem.masking
                        || item.sensitive !== originalItem.sensitive
                    ) {
                        item.id = originalItem.id
                        updateList.push(item)
                    }
                } else {
                    addList.push(item)
                }
            }

            for (let i in this.originalItemMap) {
                let item = this.originalItemMap[i]
                if (!item.doNotDelete) {
                    deleteList.push(item)
                }
            }

            let promiseList = []
            let scenario_id = this.$route.params.scenarioId
            for (let item of addList) {
                promiseList.push(ScenarioService.VariableService.create(scenario_id, item))
            }

            for (let item of updateList) {
                promiseList.push(ScenarioService.VariableService.update(scenario_id, item.id, item))
            }

            for (let item of deleteList) {
                promiseList.push(ScenarioService.VariableService.delete(scenario_id, item.id))
            }

            let i18n = {
                action: this.$t('update'),
                item: this.$t('variable')
            }

            Promise.allSettled(promiseList).then(
                resultList => {
                    this.$appService.hideLoading()
                    for (let result of resultList) {
                        if (result.status === 'rejected') {
                            this.$appService.toastError(this.$f.tc('actionFailed', i18n))
                            return
                        }
                    }
                    this.loadVariable()
                    this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                    this.close()
                }
            )
        },
        scrollBottom() {
            this.$nextTick(() => {
                this.$refs.contentDialog.scrollTo({
                    top: this.$refs.contentDialog.scrollHeight
                })
            })
        },
        notifyError(name) {
            this.$appService.toastWarning(this.$f.tc('systemVariable', {'variable': name}))
        },
    },
    watch: {
        variableList: {
            deep: true,
            handler: function (newVal) {
                this.itemList = lodash.orderBy(this.$utils.cloneObject(newVal), 'created_time')
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioVariable {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        margin: 12px 0 0 12px;
        padding: 0 12px 12px 0 !important;
        max-height: calc(85vh - 100px);
        overflow-y: auto;
        position: relative;
    }

    .btn-custom {
        margin-right: 8px;
    }
}

.tooltip .tooltiptext {
    background-color: #808080;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 4px;
    font-size: 11px;
    font-family: "open sans", serif;
    display: none;
    position: absolute;
}

.tooltip:hover .tooltiptext {
    display: block;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.input-custom-2 {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }

            .v-text-field__slot input {
                color: #e3a008;
            }

            .v-icon {
                margin-left: 15px;
                margin-bottom: 15px;
                color: #8d4b0f;
                scale: 0.8;
            }
        }
    }
}

table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    tr {
        border-bottom: 1px solid #96add0;
    }

    tr {
        td {
            padding: 0 6px;

            &:first-child {
                padding-left: 12px;
            }
        }
    }
}

.error-message {
    color: red;
    margin-top: 5px;
    font-size: 13px;
    font-family: "open sans", serif;
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-input--selection-controls {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

.additional-data {
    border: none !important;
    color: black;
    background: #E4EDFA;


    tbody {
        td {
            font-size: 13px;
            padding: 12px;
        }

        tr:nth-child(2n+2) td {
            background: #E4EDFA;
        }

        tr:nth-child(2n+1) td {
            background: #ffffff;
        }
    }
}

.v-tooltip__content {
    padding: 2px 2px;
}
</style>
